import React, { useState, useEffect } from 'react';

const TestimonialsCarousel = () => {
  const testimonials = [
  {
    "id": 1,
    "rating": 5,
    "quote": "EquiCore Nexus’ analysis and modeling were spot on—instrumental in helping us secure seed funding. Their insights are invaluable.",
    "name": "CEO",
    "position": "US Tech Startup"
  },
  {
    "id": 2,
    "rating": 5,
    "quote": "The incredible due diligence and sharp ability to uncover transaction insights from audit figures were critical in strengthening our deal negotiations.",
    "name": "Managing Director",
    "position": "Private Equity Fund"
  },
  {
    "id": 3,
    "rating": 5,
    "quote": "Their financial models gave us the clarity and confidence to close our Series A round successfully.",
    "name": "Founder",
    "position": "Fintech Startup"
  },
  {
    "id": 4,
    "rating": 5,
    "quote": "Quick modeling turnaround with detailed revenue and operational KPIs built into the model—intuitive to operate and instrumental in driving better decisions.",
    "name": "Chief Financial Officer",
    "position": "SaaS Company"
  },
  {
    "id": 5,
    "rating": 5,
    "quote": "Thanks to their insights, we optimized our fundraising strategy and exceeded our goals.",
    "name": "Investor Relations Head",
    "position": "Healthcare Startup"
  },
  {
    "id": 6,
    "rating": 5,
    "quote": "Professional, insightful, and extremely reliable — EquiCore Nexus is our preferred financial consultant.",
    "name": "Managing Partner",
    "position": "Venture Capital Firm"
  },
  {
    "id": 7,
    "rating": 5,
    "quote": "The team has been of great help and support. He has an eye for detail and analyzes even new business concepts nicely. I Recommend working with him. I will hire him again in the future.",
    "name": "CEO",
    "position": "Investment Platform"
  },
  {
    "id": 8,
    "rating": 5,
    "quote": "The Model was very good, Great Job It was approved by the client. Happy to build a long-term relationship.",
    "name": "Founder",
    "position": "Investment Banking"
  },
  {
    "id": 9,
    "rating": 5,
    "quote": "Thank you for your great help with the acquisition modeling and Due diligence service to help us make better decisions.",
    "name": "General Partner",
    "position": "PE Firm"
  },
  {
    "id": 10,
    "rating": 5,
    "quote": "He is a reliable partner for executing deals and delivering impactful pitch decks and financial models.",
    "name": "Fintech Business Owner",
    "position": ""
  }
];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    let interval;
    if (isAutoPlaying && testimonials.length > 1) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000); // Change slide every 5 seconds
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const goToPrev = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0F172A] mb-4">What Our Clients Say</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#3B82F6] to-emerald-500 mx-auto rounded-full"></div>
        </div>
        
        <div className="relative max-w-4xl mx-auto">
          {/* Carousel container */}
          <div className="overflow-hidden relative md:h-64 h-96">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className={`absolute inset-0 transition-opacity duration-500 ${index === currentIndex ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
              >
                <div className="bg-white p-8 rounded-xl shadow-md h-full">
                  <div className="flex items-center mb-4">
                    <div className="flex mr-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <span className="text-sm text-gray-500">{testimonial.category}</span>
                  </div>
                  <p className="text-gray-700 italic text-lg">
                    {testimonial.quote}
                  </p>
                  <div className="flex items-center mt-8">
                    <div>
                      <h3 className="font-semibold">{testimonial.name}</h3>
                      <p className="text-sm text-gray-600">{testimonial.position}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation arrows */}
          {testimonials.length > 1 && (
            <>
              <button 
                onClick={goToPrev}
                className="absolute left-0 top-1/2 -translate-y-1/2 md:-translate-x-12 -translate-x-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors"
                aria-label="Previous testimonial"
              >
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button 
                onClick={goToNext}
                className="absolute right-0 top-1/2 -translate-y-1/2 md:translate-x-12 translate-x-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors"
                aria-label="Next testimonial"
              >
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </>
          )}

          {/* Indicators */}
          {testimonials.length > 1 && (
            <div className="flex justify-center mt-6 space-x-4">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full ${index === currentIndex ? 'bg-blue-600' : 'bg-gray-300'}`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;